import api from '@app/services/api';
import type {
    ApiError,
    BillingReportsParams,
    BillingReportsResponse,
} from '@app/services/api.types';
import { apiEndpoints } from '@app/utils/constants';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

type QueryOptions = Omit<UseQueryOptions<BillingReportsResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchBillingReports = async (
    params: BillingReportsParams
): Promise<BillingReportsResponse> => {
    const url = apiEndpoints.billingReports.getReport(params);
    const response = await api.get(url);
    return response?.data?.data;
};

const useBillingReports = (params: BillingReportsParams, options?: QueryOptions) => {
    return useQuery<BillingReportsResponse, ApiError>({
        queryKey: ['billingReports', 'list', params],
        queryFn: () => fetchBillingReports(params),
        ...options,
        enabled: Boolean(params.start && params.end),
    });
};

export default useBillingReports;
